import { lazy } from "react"

import { RegionWrapper } from "@/components/layout/Region"
import { Loader } from "@/components/Loader"

const LoginCore = lazy(() => import("./LoginCore"))

export const Login = () => (
  <RegionWrapper
    className="m-auto flex w-full items-center justify-center"
    fallback={<Loader />}
  >
    <LoginCore />
  </RegionWrapper>
)
